import gql from 'graphql-tag';
import { toastr } from 'react-redux-toastr';

import {
  UPDATE_RIDE_FARE_STATUS_START,
  UPDATE_RIDE_FARE_STATUS_SUCCESS,
  UPDATE_RIDE_FARE_STATUS_ERROR
} from '../../../constants';

const mutation = gql`
mutation($id: Int!, $isActive: Boolean, $locationId: Int, $categoryId: Int) {
  updateRideFareStatus(id: $id, isActive: $isActive, locationId: $locationId, categoryId: $categoryId) {
    status
    errorMessage
  }
}
`;

export default function updateRideFareStatus(id, isActive, locationId, categoryId) {
  return async (dispatch, getState, { client }) => {
    dispatch({ type: UPDATE_RIDE_FARE_STATUS_START });

    try {
      const { data } = await client.mutate({
        mutation,
        variables: {
          id,
          isActive: isActive == '1',
          locationId,
          categoryId
        }
      });

      if (data && data.updateRideFareStatus && data.updateRideFareStatus.status === 200) {
        dispatch({ type: UPDATE_RIDE_FARE_STATUS_SUCCESS });
        toastr.success('Success', 'The ride fare status has been updated.');
        return { status: 200 };
      }

      const errorMessage = (data && data.updateRideFareStatus && data.updateRideFareStatus.errorMessage) || 'Oops! Something went wrong. Please try again.';
      dispatch({ type: UPDATE_RIDE_FARE_STATUS_ERROR });
      toastr.error('Error!', errorMessage);
      return { status: 400 };

    } catch (error) {
      dispatch({ type: UPDATE_RIDE_FARE_STATUS_ERROR });
      toastr.error('Error!', 'Something went wrong! ' + error);
      return { status: 400 };
    }
  };
}
